export default {
  utils: {
    components: {
      input: {
        max_chars: 'Máx. characters: {{chars}}',
      },
      button: {
        save_as_draft: 'Save as draft',
        next: 'Next',
        cancel: 'Cancel',
        create: 'Create',
        save_changes: 'Save changes',
        close: 'Close',
      },
    },
    
    schema: {
      required: 'Required field',
      select_image: 'Select an image'
    }
  },

  pages: {
    access_control: {
      components: {
        filter_box: {},
        users_table: {},
        user: {},
      },
      breadcrumb: {
        label: 'ACCESS CONTROL',
      },
      title: ''
    },

    access_control_permission_type_edit: {
      breadcrumb: {
        label: 'CONTROLE DE ACESSO',
        label2: 'PERMISSÃO PADRÃO',
        label3: 'DETALHES',
      },
    },

    login: {
      components: {
        form: {
          button_enter: 'Access',
          forgot_password: 'I forgot my password',
        },
      },
      forgot_password: {},
      forgot_password_confirm_code: {},
      forgot_password_send: {},
      two_factor_auth: {},
    },

    challenges_details: {
      page_title: 'Challenges',

      create_title: 'Create challenge',
      edit_title: 'Edit challenge',
      switch_published: 'Published',
      button_end_challenge: 'End challenge',

      breadcrumb: {
        label_1: 'Application',
        label_2: 'Challenges',
        label_3: 'Details',
      },

      schema: {
        at_least_one_question: 'Add at least one question',
        at_least_two_alternatives: 'Add at least two alternatives',
        correct_alternative: 'Select the correct alternative',
      },

      toasts: {
        create_success: 'Challenge created',
        create_error: 'An error ocurred creating the challenge. Try again',
        edit_success: 'Changes saved',
        edit_error: 'An error ocurred saving the changes. Try again',
        get_by_uuid_error: 'An error ocurred. Try again',
        publish_success: 'Challenge published',
        publish_error: 'An error ocurred publishing the challenge. Try again',
        unpublish_success: 'Challenge unpublished',
        unpublish_error: 'An error ocurred unpublishing the challenge. Try again',
        close_success: 'Challenge closed',
        close_error:  'An error ocurred closing the challenge. Try again',
      },

      tabs: {
        tab_1: {
          title: 'Information',
          input_title_label: 'Challenge title',
          input_title_placeholder: 'Interval Challenge',
          input_description_label: 'Description',
          input_description_helptext: 'Announcement of the challenge, rules and prizes for the winner',
          input_description_placeholder: 'Be the first to answer 20 questions correctly in the shortest time possible and compete for an exclusive prize!',
          input_limit_label: 'Time limit per question (in seconds)',
          input_limit_helptext: 'Time the participant has to answer each question',
          input_limit_placeholder: '10 seconds',
          switch_start_at_label: 'Set challenge start date',
          switch_start_at_helptext: 'When you publish a challenge with a set start date, it will appear on the Home Page with a countdown until it starts. If you do not set a date, it will be published immediately, already open for user participation',
          input_date_label: 'Date',
          input_date_placeholder: 'DD/MM/YYYY HH:MM',
        },

        tab_2: {
          title: 'Questions',
          title_label: 'Questions (minimum of 2)',
          title_helper: '(Máx. characters: 100)',
          image_label: 'Image',
          input_question_label: 'Question {{number}}',
          input_alternative_label: 'Alternative {{number}}',
          button_add_question: 'Add question',
          button_add_alternative: 'Add alternative',
          button_save: 'Save question',
          button_cancel: 'Cancel question',

        },

        tab_3: {
          title: 'Message',
          input_incorrect_label: 'Incorrect answer',
          input_incorrect_helptext: 'Message displayed when the participant gets a question wrong',
          input_time_label: 'Time out',
          input_time_helptext: 'Message displayed when time to answer the question ends',
          input_other_winner_label: 'Won by another participant',
          input_other_winner_helptext: 'Message displayed when another player wins the challenge before the participant',
          input_winner_label: 'Winning participant',
          input_winner_helptext: 'Message displayed to congratulate the player who completes the challenge first',
        }
      }
    },

    communication_central: {
      components: {
        notification_create_modal: {
          schedule_send_label: 'Schedule sending',
          scheduled_at_label: 'Send date and time*:',

          schema: {
            scheduled_at_required: 'Select the send date and time',
            scheduled_at_invalid: 'Invalid date and time',
            scheduled_at_future: 'The send date and time must be in the future',
            scheduled_at_should_be_empty: 'The send date and time must be empty when scheduling is disabled',
          },
        },

        notifications_tab_table: {
          column_status: 'STATUS',
          status_pending: 'Scheduled',
          status_processing: 'Scheduled',
          status_sent: 'Sent',
          status_failed: 'Failed',
        },

        notifications_tab_filter_box: {
          status_label: 'Status:',
          status_all: 'All',
        },
      },
    },
  },
};
